angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:oid/priceAndAvailability", {
        templateUrl: 'templates/price-and-availability/priceAndAvailability.html',
        controller: 'PriceAndAvailabilityController',
        title: 'availabilityAndPrice.TITLE',
        sidebar: "priceAndAvailability"
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/price-and-availability/price_and_availability_route.js
// module id = 828
// module chunks = 3